import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'app.WorkflowIdPage.MatrixPopupContent.AirwallexBenificiaryCreationConditionCell',
    {
        label: 'Can create new beneficiaries',
    }
);
